import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-v', 'LetterV', [["path",{"d":"M6 4l6 16l6 -16","key":"svg-0"}]]);